var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('date-picker',{staticClass:"clh-datepicker",attrs:{"type":_vm.type},model:{value:(_vm.cDate),callback:function ($$v) {_vm.cDate=$$v},expression:"cDate"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }